import { PropsWithChildren, ReactNode } from 'react'

import * as S from './styled'

const Cover = ({ children }: PropsWithChildren<ReactNode>) => {
  return <S.CoverWrapper>{children}</S.CoverWrapper>
}

export default Cover
